import React from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineBarChart } from "react-icons/ai";
import { MdAccessTime, MdEventBusy } from "react-icons/md";
import { BsPerson } from "react-icons/bs";

const ReportsMenu = () => {
  const navigate = useNavigate();
  const onNavigate = (route) => {
    console.log("Navigate clicked");
    navigate(route);
  };

  const leaveReportsData = [
    {
      id: 1,
      title: "Leave Balance Report",
      route: "/admin/leaveBalanceReport",
    },
    {
      id: 2,
      title: "Leave Ledger Report",
      route: "/admin/leaveLedger",
    },
    {
      id: 3,
      title: "Leave Requests & Approval Report",
      route: "/admin/leaveRequestApprovalStatus",
    },
    {
      id: 4,
      title: "Medical Leave Tracking",
      route: "/admin/medicalLeaveTracking",
    },
  ];
  const employeeReportsData = [
    {
      id: 1,
      title: "Employee Joining & Exit Report",
      route: "/admin/empJoinExitReport",
    },
    {
      id: 2,
      title: "Employee Status Report",
      route: "/admin/empStatusReport",
    },
    {
      id: 3,
      // title: "Employee Visa / ID Expiry",
      title: "Expiry Documents",
      route: "/admin/empVisaIDExpiryReport",
    },
  ];
  const attendanceReportsData = [
    {
      id: 1,
      title: "Timesheet Summary Report",
      route: "/admin/timesheetSummaryReport",
    },
    {
      id: 2,
      title: "Attendance Punch Details Report",
      route: "/admin/attendancePunchDetailsReport",
    },
    {
      id: 3,
      title: "Absence Report",
      route: "/admin/absenceReport",
    },
    {
      id: 4,
      title: "Overtime Report",
      route: "/admin/overtimeReport",
    },
    {
      id: 4,
      title: "Late Coming / Early Leaving Report",
      route: "/admin/lateEarlyReport",
    },
  ];
  return (
    <div className="grid grid-cols-3 gap-4 ">
      <div className="bg-white rounded-2xl shadow-md p-3 w-full max-w-md">
        <h2 className="flex justify-left items-center gap-2 font-bold text-md text-gray-500 mb-4 border-b pb-2">
          <MdAccessTime className="w-5 h-5 text-[#787878] group-hover:scale-110 transition-all duration-200" />
          Attendance Reports
        </h2>

        <div className="flex flex-col gap-3">
          {attendanceReportsData?.map((item, index) => (
            <button
              key={index}
              onClick={() => onNavigate(item.route)}
              className="flex items-center gap-3 px-4 py-2.5 rounded-lg 
                   bg-blue-50 text-blue-700 font-medium 
                   hover:bg-blue-500 hover:text-white 
                   transition-all duration-200 group shadow-sm"
            >
              <AiOutlineBarChart className="text-lg group-hover:scale-110 transition-transform duration-200" />

              <span className="text-sm">{item.title}</span>
            </button>
          ))}
        </div>
      </div>
      <div className="bg-white rounded-2xl shadow-md p-3 w-full max-w-md">
        <h2 className="flex justify-left items-center gap-2 font-bold text-md text-gray-500 mb-4 border-b pb-2">
          <MdEventBusy className="w-5 h-5 text-[#787878] group-hover:scale-110 transition-all duration-200" />
          Leave Reports
        </h2>

        <div className="flex flex-col gap-3">
          {leaveReportsData?.map((item, index) => (
            <button
              key={index}
              onClick={() => onNavigate(item.route)}
              className="flex items-center gap-3 px-4 py-2.5 rounded-lg 
              bg-blue-50 text-blue-700 font-medium 
              hover:bg-blue-500 hover:text-white 
              transition-all duration-200 group shadow-sm"
            >
              <AiOutlineBarChart className="text-lg group-hover:scale-110 transition-transform duration-200" />

              <span className="text-sm">{item.title}</span>
            </button>
          ))}
        </div>
      </div>
      <div className="bg-white rounded-2xl shadow-md p-3 w-full max-w-md">
        <h2 className="flex justify-left items-center gap-2 font-bold text-md text-gray-500 mb-4 border-b pb-2">
          <BsPerson className="w-5 h-5 text-[#787878] group-hover:scale-110 transition-all duration-200" />
          Employee Reports
        </h2>

        <div className="flex flex-col gap-3">
          {employeeReportsData?.map((item, index) => (
            <button
              key={index}
              onClick={() => onNavigate(item.route)}
              className="flex items-center gap-3 px-4 py-2.5 rounded-lg 
                   bg-blue-50 text-blue-700 font-medium 
                   hover:bg-blue-500 hover:text-white 
                   transition-all duration-200 group shadow-sm"
            >
              <AiOutlineBarChart className="text-lg group-hover:scale-110 transition-transform duration-200" />

              <span className="text-sm">{item.title}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReportsMenu;
